import ZigZagCards from "../components/zig-zag-cards/ZigZagCards";
import '../components/cards/CardSection';
import './petroleum.css';
import CardSection from "../components/cards/CardSection";
import Map from "../components/map/Map";

const Petroleum = () => {

  const zigzagCardsData = [
    {
      title: 'Gas Station & Convenience Store Portfolio',
      description: <span>
        <ul>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Yucaipa Gas Mart
            </span>
            <span className="zig-zag-card-sub-address">
              31340 Hampton Rd, Yucaipa, CA 92399
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Beaumont Gas Mart
            </span>
            <span className="zig-zag-card-sub-address">
              1696 E. Street, Beaumont, CA 92223
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            NBA Investments Inc
            </span>
            <span className="zig-zag-card-sub-address">
            22755 Palm Drive, Desert Hot Spring, CA 92240
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
              Nordhal Petro Inc
            </span>
            <span className="zig-zag-card-sub-address">
            2838 Auto Park Way, Escondido, CA 92129
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
              Trisha Investments LLC
            </span>
            <span className="zig-zag-card-sub-address">
            16466 Perris Blvd. Moreno Valley, CA 92553
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
              Trisha Petro Inc
            </span>
            <span className="zig-zag-card-sub-address">
            2156 S. Grove Ave, Ontario, CA 91761
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
              Parth Petro Inc
            </span>
            <span className="zig-zag-card-sub-address">
            12201 Mountain Ave, Chino, CA 91710
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Snk Investments Inc
            </span>
            <span className="zig-zag-card-sub-address">
            13691 Central  Ave, Chino, CA 91710
            </span>
          </li>
        </ul>
        <ul>
        <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Ruchi Petro Inc
            </span>
            <span className="zig-zag-card-sub-address">
            833 N. Ramona Blvd, San Jacinto, CA 92582
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Grand Petro Inc
            </span>
            <span className="zig-zag-card-sub-address">
            21530 Valley Blvd, City Of Industry, CA 91789
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Action Petro
            </span>
            <span className="zig-zag-card-sub-address">
            2191 W. Main St, Barstow, CA 92331
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Oceanside Petro
            </span>
            <span className="zig-zag-card-sub-address">
            1920 Mission Ave, Oceanside, CA 92058
            </span>
          </li>
          <li>
            <span  className="zig-zag-card-sub-heading">
              Arco ampm 
            </span>
            <span className="zig-zag-card-sub-heading">
            Banning Petro
            </span>
            <span className="zig-zag-card-sub-address">
            2228 West Ramsey St, Banning, CA 92220
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
              Arco
            </span>
            <span className="zig-zag-card-sub-address">
              Trisha Enterprises
            </span>
            <span className="zig-zag-card-sub-address">
              34841 Yucaipa Blvd Yucaipa, CA 92399
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
              Chevron
            </span>
            <span className="zig-zag-card-sub-address">
              Canyon Oil
            </span>
            <span className="zig-zag-card-sub-address">
            3686 East Route 66 Flagstaff, AZ 86004
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
            7 Days Market & Gas
            </span>
            <span className="zig-zag-card-sub-address">
            3660 E Florida Ave, Hemet, CA 92544
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
            Qwik Corner Market & Gas
            </span>
            <span className="zig-zag-card-sub-address">
            25760 New Chicago Ave, Hemet, CA 92544
            </span>
          </li>
        </ul>
      </span>,
      image: '/arco-pertroleum-gas-station.jpg',
    }
  ];

  const mapData = [
    {
     name: "Yucaipa Gas Mart",
     imageurl: '/petroleum/Yucaipa-Gas-Mart.png',
     address: "31340 Hampton Rd, Yucaipa, CA 92399"
    },
    {
     name: "Beaumont Gas Mart",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "1696 E. Street, Beaumont, CA 92223"
    },
    {
     name: "NBA Investments Inc",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "22755 Palm Drive, Desert Hot Spring, CA 92240"
    },
    {
     name: "Nordhal Petro Inc",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "2838 Auto Park Way, Escondido, CA 92129"
    },
    {
     name: "Trisha Investments LLC",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "16466 Perris Blvd. Moreno Valley, CA 92553"
    },
    {
      name: "Trisha Petro Inc",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "2156 S. Grove Ave, Ontario, CA 91761"
    },
    {
      name: "Parth Petro Inc",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "12201 Mountain Ave, Chino, CA 91710"
    },
    {
      name: "Snk Investments Inc",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "13691 Central  Ave, Chino, CA 91710"
    },
    {
      name: "Richi Petro Inc",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "833 N. Ramona Blvd, San Jacinto, CA 92582"
    },
    {
      name: "Grand Petro Inc",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "21530 Valley Blvd, City Of Industry, CA 91789"
    },
    {
      name: "Action Petro",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "2191 W. Main St, Barstow, CA 92331"
    },
    {
      name: "Oceanside Petro",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "1920 Mission Ave, Oceanside, CA 92058"
    },
    {
      name: "Banning Petro",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "2228 West Ramsey St, Banning, CA 92220"
    },
    {
      name: "7 Days Market & Gas",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "3660 E Florida Ave, Hemet, CA 92544"
    },
    {
      name: "Qwik Corner Market & Gas",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "25760 New Chicago Ave, Hemet, CA 92544"
    }
          
  ];

  
  return (
    <div className="petroleum-container">
      <div className="banner-section">
        <img src="/ARCA.png" />
        <h1>
          GAS STATION & CONVENIENCE STORE PORTFOLIO
        </h1>
      </div>
      <div className="content-section">
        <ZigZagCards cards={zigzagCardsData}  />
        {/* <Map data={mapData} /> */}
      </div>
    </div>
  );

};

export default Petroleum;